<template>
	<div id='pay'>
		<div id="info">
			<p>计费说明：</p>
			<p>证件照制作及换装：客户每支付一个订单为一次有效订单。</p>
			<p>
				大量购买请联系：18014955375。
			</p>
			<p>
				对公打款和开票事宜，请联系18014955375。支持电子普票和开具6%的增值税专用发票。
			</p>
		</div>
		
		<div id="amount" class="big-container">
			<div class="pay-item-label" id="label1">充值数量：5000次</div>
		</div>
		<div id="total-price" class="big-container">
			<div class="pay-item-label" id="label2">根据您为产品选择的登录方式，应付金额为：<span id="price-big" class="total-fee">{{fee}}</span>元</div>
		</div>
		<p class="pay-sp">
			*以上所有资费不含税，可直接在线开具电子普票，若需开具6%的增值税专用发票，请联系18014955375
		</p>
		<div id="pay-type" class="big-container">
			<div class="pay-item-label" id="label3">充值方式：</div>
			<div class="pay-type-items">
				<div class="pay-box" :class="chosenPayWay=='wechat'?'item-selected':''" id="wechat" @click="chosenPayWay='wechat'">
					<img src="../assets/wxpay.png" />
				</div>
				<div class="pay-box" :class="chosenPayWay=='alipay'?'item-selected':''" id="alipay" @click="chosenPayWay='alipay'">
					<img src="../assets/alipayWay.png" />
				</div>
			</div>
		</div>

		<p class="pay-sp">*如需对公汇款请联系：18014955375</p>

		<div id="qr-container" class="big-container">
			<img :src="payInfo[chosenPayWay].qrcode" id='qr-code' />
			<div id="pay-alert">
				<div>打开{{chosenPayWay=='wechat'?"微信":"支付宝"}}，扫描二维码付款</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapActions, mapState 
	} from "vuex";
	import {
		createChargeOrder,
		pollingChargeOrder
	} from '../api/index.js';
	export default {
		data() {
			return {
				chosenPayWay:'wechat',
				fee:'',
				payInfo:{
					wechat:{
						qrcode:'',
						order_id:''
					},
					alipay:{
						qrcode:'',
						order_id:''
					}
				},
				interval:null
			}
		},
		computed:{
			...mapState([
				"app_info",
			]),
		},
		created() {
			if(this.app_info.webapp_key){
				let param={
					webapp_key:this.app_info.webapp_key,
					fee_type:1
				}
				createChargeOrder({...param,pay_type:2}).then(res=>{
					if(res.data.code==200){
						this.fee = parseFloat(res.data.fee/100);
						this.payInfo.wechat.order_id = res.data.order_id;
						this.payInfo.wechat.qrcode = "data:image/png;base64," + res.data.qrcode;
						this.pollingResult()
					}else{
						this.$message.error('生成订单失败')
					}
				}).catch(err=>{
					console.log(err);
					this.$message.error('生成订单失败')
				})
				createChargeOrder({...param,pay_type:1}).then(res=>{
					if(res.data.code==200){
						this.fee = parseFloat(res.data.fee/100);
						this.payInfo.alipay.order_id = res.data.order_id;
						this.payInfo.alipay.qrcode = "data:image/png;base64," + res.data.qrcode;
					}else{
						this.$message.error('生成订单失败')
					}
				}).catch(err=>{
					console.log(err);
					this.$message.error('生成订单失败')
				})
			}else{
				this.$message.error('非法进入')
				this.$router.replace("/setBasicInfo")
			}
		},
		methods:{
			...mapActions([
				"getAppInfoFromServer"
			]),
			pollingResult:function(){
				let order_id = this.payInfo[this.chosenPayWay].order_id;
				pollingChargeOrder({order_id:order_id}).then(res=>{
					if(res.data.code==200){
						this.$message({
							message: '支付成功，正在返回后台',
							type: 'success'
						});
						this.getAppInfoFromServer().then(()=>{
							this.$router.replace("/setBasicInfo")
						}).catch(err=>{
							console.log(err)
							this.$message.error('系统错误，请联系管理员')
						})
					}else {
						this.interval = setTimeout(() => {
							this.pollingResult();
						}, 2000);
					}
				})
			}
		}
	}
</script>

<style scoped="scoped">
	#pay {
		margin: 30px 40px;
		box-shadow: 0px 4px 12px 0px rgba(66, 66, 66, 0.1);
		border-radius: 10px;
		padding: 20px 80px;
		font-size: 16px;
		/* font-weight: bold; */
		color: #4C4C4C;
	}
	.big-container{
		margin-top: 24px;
	}
	#info {
		padding: 17px 30px 11px;
		background: rgba(243, 246, 255, 1);
		font-size: 14px;
		color: #4d7df5;
		margin-top: 30px;
		border: 1px dotted #4d7df5;
		border-radius: 2px;
		box-sizing: border-box;
	}

	#info p {
		margin-bottom: 9px;
	}
	#price-big{
		color: #F60;
		font-size: 30px;
		font-weight: 500;
	}
	.pay-sp{
		margin-top: 10px;
		font-size: 14px;
		color: #A9A9A9;
		margin-left: 80px;
	}
	.pay-box{
		margin-right: 24px;
		border: 1px solid #e5e5e5;
		display: inline-block;
		width: 222px;
		height: 80px;
		margin-bottom: 12px;
		padding: 19px 45px;
		box-sizing: border-box;
	}
	.item-selected{
		border: 2px solid #FF873E !important;
		background: url(../assets/selected.png) bottom right no-repeat;
	}
	#pay-type{
		
	}
	.pay-item-label{
		display: inline-block;
	}
	.pay-type-items{
		display: inline-flex;
		align-items: center;
	}
	#pay-alert{
		width: 220px;
		height: 40px;
		background: #4D7DF5;
		color: #FFF;
		font-size: 14px;
		text-align: center;
		line-height: 40px;
	}
	#qr-code{
		width: 218px;
		height: 218px;
		border: 1px solid #e5e5e5;
		margin-top: 15px;
		margin-bottom: 15px;
	}
	#qr-container{
		margin-left: 80px;
	}
</style>
